import React, { useState, useEffect } from 'react';
import { Shield, X } from 'lucide-react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Small delay so it doesn't flash on load
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 animate-in slide-in-from-bottom" data-testid="cookie-consent-banner">
      <div className="max-w-4xl mx-auto bg-slate-900 rounded-2xl shadow-2xl shadow-black/20 p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Shield size={20} className="text-orange-400 shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-white font-medium">Cookie-Einstellungen</p>
            <p className="text-xs text-slate-400 mt-1 leading-relaxed">
              Wir verwenden Cookies, um Ihre Nutzungserfahrung zu verbessern. Mehr dazu in unserer{' '}
              <a href="/datenschutz" className="text-orange-400 hover:underline">Datenschutzerklärung</a>.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={decline}
            className="px-4 py-2 text-xs font-medium text-slate-400 hover:text-white border border-slate-700 rounded-lg transition-colors"
            data-testid="cookie-decline-btn"
          >
            Ablehnen
          </button>
          <button
            onClick={accept}
            className="px-5 py-2 text-xs font-semibold bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
            data-testid="cookie-accept-btn"
          >
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
}
